import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../DIContainer';
import { SubscriptionService } from './SubscriptionService';
import { NotificationsService } from './NotificationsService';
import { AuthService } from './AuthService';
import { BookmarkService } from './BookmarkService';
import { ChannelSeriesHistoryService } from './ChannelSeriesHistoryService';
import { CmsService } from './CmsService';
import { DeviceService } from './DeviceService';
import { DiscountService } from './DiscountService';
import { EntitlementService } from './EntitlementService';
import { GatewayService } from './GatewayService';
import { GeoLocationService } from './GeoLocationService';
import { MpxService } from './MpxService';
import { PopcornService } from './PopcornService';
import { ProfileService } from './ProfileService';
import { ReminderService } from './ReminderService';
import { ThinkAnalyticsSearchService } from './ThinkAnalyticsSearchService';
import { UserIdentityService } from './UserIdentityService';
import { UserRevisionService } from './UserRevisionService';
import { UserService } from './UserService';
import { ZendeskService } from './ZendeskService';
import { ChannelService } from './ChannelService';
import { SlpService } from './SlpService';
import { IPaymentConfigService, PaymentConfigService } from './PaymentConfigService';
import { LearnActionService } from './LearnActionService';
import { ThinkAnalyticsService } from './ThinkAnalyticsService';
import { CustomConfigurationService } from './CustomConfigurationService';
import { UserRegistrationService } from './UserRegistrationService';
import { CmsCarouselService } from './CmsCarouselService';
import { StreamHarnessService } from './StreamHarnessService';
import { RewardService } from './RewardService';

export const initializeServices = (container: Container) => {
    container.register(DI.SERVICES.IAuthService, {
        useClass: AuthService,
    });
    container.register(DI.SERVICES.IBookmarkService, {
        useClass: BookmarkService,
    });
    container.register(DI.SERVICES.ICmsService, {
        useClass: CmsService,
    });
    container.register(DI.SERVICES.IChannelService, {
        useClass: ChannelService,
    });
    container.register(DI.SERVICES.IChannelSeriesHistoryService, {
        useClass: ChannelSeriesHistoryService,
    });
    container.register(DI.SERVICES.IDiscountService, {
        useClass: DiscountService,
    });
    container.register(DI.SERVICES.IDeviceService, {
        useClass: DeviceService,
    });
    container.register(DI.SERVICES.IEntitlementService, {
        useClass: EntitlementService,
    });
    container.register(DI.SERVICES.IPopcornService, {
        useClass: PopcornService,
    });
    container.register(DI.SERVICES.IGeoLocationService, {
        useClass: GeoLocationService,
    });
    container.register(DI.SERVICES.IGatewayService, {
        useClass: GatewayService,
    });
    container.register(DI.SERVICES.ILearnActionService, {
        useClass: LearnActionService,
    });
    container.register(DI.SERVICES.IMpxService, {
        useClass: MpxService,
    });
    container.register(DI.SERVICES.INotificationsService, {
        useClass: NotificationsService,
    });
    container.register(DI.SERVICES.IPopcornService, {
        useClass: PopcornService,
    });
    container.register(DI.SERVICES.IProfileService, {
        useClass: ProfileService,
    });
    container.register<IPaymentConfigService>(DI.SERVICES.IPaymentConfigService, {
        useClass: PaymentConfigService,
    });
    container.register(DI.SERVICES.IReminderService, {
        useClass: ReminderService,
    });
    container.register(DI.SERVICES.ISubscriptionService, {
        useClass: SubscriptionService,
    });
    container.register(DI.SERVICES.ISlpService, {
        useClass: SlpService,
    });
    container.register(DI.SERVICES.IThinkAnalyticsService, {
        useClass: ThinkAnalyticsService,
    });
    container.register(DI.SERVICES.IThinkAnalyticsSearchService, {
        useClass: ThinkAnalyticsSearchService,
    });
    container.register(DI.SERVICES.IUserRevisionService, {
        useClass: UserRevisionService,
    });
    container.register(DI.SERVICES.IUserIdentityService, {
        useClass: UserIdentityService,
    });
    container.register(DI.SERVICES.IUserService, {
        useClass: UserService,
    });
    container.register(DI.SERVICES.IZenDeskService, {
        useClass: ZendeskService,
    });
    container.register(DI.SERVICES.ICustomConfigurationService, {
        useClass: CustomConfigurationService,
    });
    container.register(DI.SERVICES.IUserRegistrationService, {
        useClass: UserRegistrationService,
    });
    container.register(DI.SERVICES.ICmsCarouselService, {
        useClass: CmsCarouselService,
    });
    container.register(DI.SERVICES.IStreamHarnessService, {
        useClass: StreamHarnessService,
    });
    container.register(DI.SERVICES.IRewardService, {
        useClass: RewardService,
    });
};
